var _module_exports = "<iframe id=\"autoalertiframe\" class=\"iframe-autoalert\" ng-src=\"{{$ctrl.src}}\" frameborder=\"0\" scrolling=\"yes\" height=\"100%\" width=\"100%\"></iframe>";;
var path = '/app/components/login.component.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;